// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {SwitchInterestModuleLayout} from 'app_components/modules/newsEvents/switchInterest'
// @end

// @import events
// @end

// @import utils
import {I18nUtil} from 'app_utils/i18n'
// @end

// @import services
// @end

// @import types
import { IContentInterestItems } from 'app_types/campus/contentInterest/contentInterestTypes'
// @end

// @ADD Component types
interface ISwitchInterestModuleProps {
  only?: IContentInterestItems[]      // Definir los tabs a renderizar
  hideTitle?: boolean
  hideSubtitle?: boolean
  locations?: Array<string>
}
interface ISwitchInterestModuleState {
  modules: Array<any>
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class SwitchInterestModule extends Component<ISwitchInterestModuleProps, ISwitchInterestModuleState> {

  private i18nUtil: I18nUtil

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: ISwitchInterestModuleProps) {
    super(props)
    this.state = {
      modules: []
    }

    this.i18nUtil = new I18nUtil()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {
    let modules: Array<any> = [
      {
        key: 'webinar',
        title: this.i18nUtil.getTranslate('modules.content_interest.items.webinar'),
        type: 'post',
        view_more: {
          link: '/webinars'
        }
      },
      {
        key: 'capsules',
        title: this.i18nUtil.getTranslate('modules.content_interest.items.capsules'),
        type: 'post',
        view_more: {
          link: '/capsulas'
        }
      },
      {
        key: 'moocs',
        title: this.i18nUtil.getTranslate('modules.content_interest.items.moocs'),
        type: 'mooc',
        view_more: {
          link: '/cursos'
        }
      },
      {
        key: 'blog',
        title: this.i18nUtil.getTranslate('modules.content_interest.items.blog'),
        type: 'post',
        view_more: {
          link: '/blogs'
        }
      },
      {
        key: 'research',
        title: this.i18nUtil.getTranslate('modules.content_interest.items.research'),
        type: 'post',
        view_more: {
          link: '/articulos'
        }
      },
      {
        key: 'podcast',
        title: this.i18nUtil.getTranslate('modules.content_interest.items.podcast'),
        type: 'post',
        view_more: {
          link: '/podcasts'
        }
      },
      {
        key: 'journal',
        title: 'Boletín',
        type: 'post',
        view_more: {
          link: '/journals'
        }
      }
    ]

    // @INFO Reviso si viene el prop only para filtrar
    if(this.props.only && Array.isArray(this.props.only)){
      modules = modules.filter((_m) => this.props.only?.includes(_m.key))
    }

    this.setState({
      modules
    })

  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  render() {
    return(
      <SwitchInterestModuleLayout
        hideSubtitle={this.props.hideSubtitle}
        hideTitle={this.props.hideTitle}
        modules={this.state.modules}
        locations={this.props.locations}
      />
    )
  }
}

export default connect(mapStatesToProps)(SwitchInterestModule)
